export enum NoteAudienceValue {
    VETERINARY = 'VETERINARY',
    // PUBLIC (pet-parent-facing) is intentionally out of this slice; re-add when that audience ships.
    CUSTOMER_CARE = 'CUSTOMER_CARE',
}

export const DEFAULT_NOTE_AUDIENCE = NoteAudienceValue.VETERINARY;

// Order shown in the audience selector.
export const CLAIM_SUMMARY_AUDIENCES: NoteAudienceValue[] = [
    NoteAudienceValue.VETERINARY,
    NoteAudienceValue.CUSTOMER_CARE,
];
